import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import React from "react";
import { GoEye } from "react-icons/go";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Dependent_Addition_Ops2_Edit from "./dependent_addition_ops2_edit";
import nodeinstance from "../../../../nodeInstance";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";

export default function DependentAddition_Ops2({
  dependentDetails,
  setTrigger,
  trigger,
  titles,
  index,
}) {
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(dependentDetails?.data || []);
  const [fileter, setFilter] = useState("");
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${monthName.toLowerCase()}-${year}`;
  };
  const [searchWords, setSearchWords] = useState([]);

  const navigate = useNavigate();

  const location = useLocation();
  const [routeCheck, setRouteCheck] = useState(false);
  const [details, setDetails] = useState();
  const OnIconClick = (data) => {
    navigate("/dashboard/dependent-addition/edit_OPS2");
    setDetails(data);
  };
  useEffect(() => {
    if (location.pathname.split("/")[3] === "edit_OPS2") {
      setRouteCheck(true);
    } else {
      setRouteCheck(false);
    }
  }, [location]);
  console.log(
    "Location need to be seen here.....",
    location.pathname.split("/")[3]
  );
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/excelDownload/OPS2`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `OPS_2_REPORT`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  console.log("filter date should be poppulated here....",fileter)
  const formattedInputDate = fileter ? formatDate(fileter) : "";

// Filter the list based on the iqama expiry date if input date is provided
const filteredList = !fileter
  ? currentList
  : currentList.filter((list) => {
      const formattedIqamaExpiryDate = formatDate(list.iqama_expiry_date_g);
      return formattedIqamaExpiryDate === formattedInputDate;
    });
  return (
    <>
      {routeCheck ? (
        <Dependent_Addition_Ops2_Edit
          details={details}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        <>
          <div className="flex gap-x-4 mt-4">
            <Search
             searchKey={[
              "request_type",
              "employee_name",
              "emp_id",
              "actual_profession",
              "nationality",
              "iqama_number",
            ]}
              setSearchWords={setSearchWords}
            />
            <button
              className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
              onClick={() => downloadFile()}
            >
              DOWNLOAD
            </button>
            <input
              type="date"
              className="px-4 rounded-md"
              onChange={(e) => {
                setFilter(e.target.value);
              }}
            />
          </div>

          <div
            className={`grid grid-cols-table-workflow-ops2 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md mt-10`}
          >
            {/* <button onClick={clickHandeler}>ACTION</button> */}
            {titles.map((t, index) => (
              <p key={index} className="font-semibold uppercase">
                {t}
              </p>
            ))}

            {!dependentDetails || !filteredList ? (
              <NoDataFound />
            ) : (
              filteredList?.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.approved_date
                          ? formatDate(list.approved_date)
                          : "----"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.request_type || "-"}
                    />
                  </p>
                  <p>{list.employee_count || "-"}</p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_name || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.emp_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.gender || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.nationality || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.actual_profession || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client_name || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_number || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_expiry_date_g || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.project || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.insurance_class || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.status || "-"}
                    />
                  </p>

                  <div
                    className="ml-2 cursor-pointer"
                    // onClick={() => uploadFile(list)}
                    onClick={() => {
                      OnIconClick(list);
                    }}
                  >
                    <GoEye fontSize={22} />
                  </div>

                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))
            )}
          </div>

          <Pagination />
        </>
      )}
    </>
  );
}
